import React, { useState, useEffect } from 'react';
import { getPriceFeedSymbols } from '@cai/shared/networks';
import PricesService from '../../services/prices.service';

const FALLBACK_TOKENS = getPriceFeedSymbols().map((symbol) => ({
  symbol,
  price: 0,
  change24h: 0,
}));

const POLL_MS = 60_000;

const fmt = (price) =>
  price >= 100
    ? price.toLocaleString(undefined, { maximumFractionDigits: 0 })
    : price.toFixed(price >= 1 ? 2 : 3);

const TokenRow = ({ tokens }) => (
  <>
    {tokens.map((token, index) => (
      <span className="tok" key={`${token.symbol}-${token.network ?? index}`}>
        <span className="s">{token.symbol}</span>
        <span className="p">${fmt(token.price)}</span>
        <span className={`c ${token.change24h >= 0 ? 'u' : 'd'}`}>
          {token.change24h >= 0 ? '▲' : '▼'}
          {Math.abs(token.change24h).toFixed(1)}%
        </span>
      </span>
    ))}
  </>
);

const CvTokenTicker = () => {
  const [tokens, setTokens] = useState(FALLBACK_TOKENS);

  useEffect(() => {
    let active = true;

    const loadPrices = async () => {
      try {
        const { data } = await PricesService.getTokenPrices();
        const nextTokens = data?.data?.tokens;
        if (active && Array.isArray(nextTokens) && nextTokens.length) {
          setTokens(nextTokens);
        }
      } catch {
        // Keep last known prices on failure.
      }
    };

    loadPrices();
    const id = setInterval(loadPrices, POLL_MS);
    return () => {
      active = false;
      clearInterval(id);
    };
  }, []);

  return (
    <div className="tok-strip">
      <div className="tok-lbl">
        <span className="d" />
        PRICES
      </div>
      <div className="tok-tr">
        <div className="tok-run">
          <TokenRow tokens={tokens} />
          <TokenRow tokens={tokens} />
        </div>
      </div>
    </div>
  );
};

export default CvTokenTicker;
